import request from '../utils/request';

export const fetchCountries = async (countryInitials: string) => {
    const results = await request.get(`/countries?initials=${countryInitials}`);
    return results.data;
};

export const fetchAllCountries = async () => {
    const results = await request.get('/countries');
    return results.data;
};

export const fetchCountry = async (countryCode: string) => {
    const results = await request.get(`/countries/${countryCode}`);
    return results.data;
};

export const fetchCities = async (
    countryCode: string,
    cityInitials: string
) => {
    const results = await request.get(
        `/cities?country=${countryCode}&query=${cityInitials}`
    );
    return results.data;
};

export const fetchAllCountryCities = async (countryCode: string) => {
    const results = await request.get(
        `/geo-data/cities?countryCode=${countryCode}`
    );
    return results.data;
};
